import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  tr,
  th,
  td,
  thead,
  Table,
  div,
  tbody,
  Button,
  Alert,
  FormGroup,
  FormControl,
  InputGroup,
  Glyphicon,
  DropdownButton,
  MenuItem,
  ButtonGroup,
  Modal,
  ControlLabel
} from "react-bootstrap";
import { Breadcrumb as BreadcrumbComponent } from "../../../components";
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import { createBrowserHistory } from "history";
import { withRouter, Link } from "react-router-dom";
import {
  storeCredit, storePreview
} from "../../../redux/actions/subAdminActions";
import { Notification } from "../../../components/notifications";
import isEmpty from "lodash.isempty";
import Pagination from "react-paginating";
import "../../../style/react-paginating.css";
import Dialog from "react-bootstrap-dialog";
import { renderAlert, clearAlert } from "../../../redux/actions/alertsActions";
import "../../../style/listPage.scss";
import DatePicker from "react-date-picker";

const history = createBrowserHistory();
let userID;
class StoreCreditPreview extends Component {
  static contextTypes = {
    router: PropTypes.object
  }
  constructor(props) {
    super(props);
    this.state = {  
      alertMessage: "",
      msgType: "success",
      path: ["Home", "Store Credit"],
      show: false,
      popUpStatus: false,
      userID: '',
      method: '',
      reason: '',
      expiryDate: '',
      amount: '',
      storeCredit: '',
    };
    this.handleDismiss = this.handleDismiss.bind(this);
    this.handleShow = this.handleShow.bind(this);
  }

  hadleStoreCredit = (e) => {
  	let valid = this.validation();
  	if(valid){
  		const constData = {
  			provided_to: this.state.userID,
  			credit: this.state.amount,
  			reason: this.state.reason,
  			expiryDate: this.state.expiryDate,
  			type: this.state.method,
  		}
  		this.props.storeCredit(constData);
  	}
  }

  validation = (e) => {
  	let response = true;

  	if(!this.state.amount){
  		response = false;
  		this.setState({amountError: 'red'});
  	}

  	if(!this.state.reason){
  		response = false;
  		this.setState({reasonError: 'red'});
  	}

  	return response;
  }

  onChangeExpiryDate = date => this.setState({ expiryDate: date });

  handleOnChange = (e) => {
  	if (`${e.target.name}Error` !== "") {
      this.setState({ [`${e.target.name}Error`]: "" });
    }
    this.setState({[e.target.name]: e.target.value});
  }

  changeStatus = (userID, method) => {
    this.setState({popUpStatus: true, userID: userID, method: method});
  }

  ClosePopup = (e) => {
    this.setState({popUpStatus: false, userID: '', method: '', amount:'', reason:'', expiryDate: ''});
  }


  handleDismiss() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  componentWillMount() {
    this.handleDismiss();
    this.props.clearAlert();
    this.handlePageChange();
  }
  handlePageChange = page => {
    userID = (this.props.match.params.userID) ? this.props.match.params.userID : '';
    this.props.storePreview(userID);
  };

  componentWillReceiveProps(nextProps) {
    if (this.props.storePrev !== nextProps.storePrev) {
      if (nextProps.storePrev) {
        this.setState({
          storeCredit: nextProps.storePrev,
        });
      }
    }

    if(this.props.store !== nextProps.store){
    	if (nextProps.store) {
	        this.setState({ alert: false });
	        this.props.clearAlert();
	        this.handleShow();
	        this.props.renderAlert("success", nextProps.store.message);
	        this.setState({popUpStatus: false, userID: '', method: '', amount:'', reason:'', expiryDate: ''});
	        this.handlePageChange();
	    }
    }
    
    if (this.props.error !== nextProps.error) {
      if (nextProps.error) {
        this.setState({ alert: false });
        this.props.clearAlert();
        this.handleShow();
        this.props.renderAlert("warning", nextProps.error);
      }
    }

    if (nextProps.message) {
      this.setState({
        alertMessage: nextProps.message,
        msgType: nextProps.alertType
      });
    }
  }

  render() {
    const { path } = this.state;
    const { currentPage, totalRecords, perPage, pageCount } = this.state;
    let storeRow;
    if (!isEmpty(this.state.storeCredit)) {
      storeRow = this.state.storeCredit.data.map((store, index) => (
        <tr key={Math.random() + index}>
          <td className={(store.type === 'deposit') ? 'text-success' : 'text-danger'}>{(store.type === 'deposit') ? 'Deposit' : 'Withdrawal'}</td>
          <td>{store.reason}</td>
          <td>{store.credit}</td>
          <td>{store.created_on1}</td>
          <td>{(store.expiryDate) ? store.expiryDate : '-'}</td>
        </tr>
      ));
    }

    return (
      <div>
        <Dialog
          ref={el => {
            this.dialog = el;
          }}
        />
        <div className="col-lg-12 user-list list-page">
          <div className="row">
            <div className="col-xs-12">
              <BreadcrumbComponent path={this.state.path} />
            </div>
          </div>
          <div className="panel">
            <header className="panel-heading">Store Credit</header>

            <div className="panel-body">
              {this.state.show &&
                this.state.alertMessage !== "" && (
                  <div className="col-lg-12">
                    <Alert
                      bsStyle={this.state.msgType}
                      onDismiss={this.handleDismiss}
                    >
                      <strong>{this.state.msgType}:</strong>{" "}
                      {this.state.alertMessage}
                    </Alert>
                  </div>
                )}
              <div className="row">
                <div className="col-lg-12 text-right">
                  <Button
                    bsSize="small"
                    bsStyle="success"
                    onClick={this.changeStatus.bind(
                      this,
                      userID,
                      'deposit'
                    )}
                  >
                    + Add Credit
                  </Button>
                  <Button
                    bsSize="small"
                    bsStyle="danger"
                    onClick={this.changeStatus.bind(
                      this,
                      userID,
                      'withdrawl'
                    )}
                  >
                    - Remove Credit
                  </Button>
                  {/*<Button
                    bsSize="small"
                    bsStyle="success"
                    onClick={() => this.context.router.history.push("/store-credit")}
                  >
                    User List
                  </Button>*/}
                </div>
              </div>
              <div className="clearfix" />
              <div className="row m-t-15">
              
              </div>
              <div className="col-lg-12">
                <table className="table table-hover">
                  <thead>
                    <tr>
                      <th>
                        Type
                      </th>
                      <th>
                        Reason
                      </th>
                      <th>
                        Amount
                      </th>
                      <th>Date</th>
                      <th>Expires At</th>
                    </tr>
                  </thead>
                  <tbody>{storeRow}</tbody>
                </table>

                
              </div>
              <div className="clearfix" />
            </div>
          </div>
        </div>
        <Modal show={this.state.popUpStatus} onHide={this.ClosePopup}>
          <Modal.Header closeButton>
            <Modal.Title><i className="fa fa-money"></i>{" "}{(this.state.method === 'deposit') ? 'Add Store Credit' : 'Remove Store Credit'}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
             <p className="text-danger">The reason can be seen by the user, keep it clean and unpretentious</p>
             <FormGroup>
                  <ControlLabel>Reason</ControlLabel>
                  <FormControl
                    type="text"
                    value={this.state.reason}
                    placeholder="Enter Reason"
                    name="reason"
                    onChange={this.handleOnChange}
                    style={{borderColor:this.state.reasonError}}
                  />
            </FormGroup>
            <FormGroup>
                <ControlLabel>Amount</ControlLabel>
			    <InputGroup>
			      <DropdownButton
			        componentClass={InputGroup.Button}
			        id="input-dropdown-addon"
			        title="$"
			      >
			        <MenuItem key="$">$</MenuItem>
			      </DropdownButton>
			      <FormControl 
			      	type="number" 
			      	value={this.state.amount} 
			      	onChange={this.handleOnChange}
			      	name="amount"
                    style={{borderColor:this.state.amountError}} 
                   />
			    </InputGroup>
			</FormGroup>
			{(this.state.method === 'deposit') &&
			<FormGroup>
                <ControlLabel>Expiry Date (Optional)</ControlLabel><br/>
                <DatePicker
                        onChange={this.onChangeExpiryDate}
                        value={this.state.expiryDate}
                      />
            </FormGroup>
        	}
          </Modal.Body>
          <Modal.Footer>
            {(this.state.method === 'deposit') ?
            	<Button bsStyle="success" onClick={this.hadleStoreCredit}>Deposit</Button>
            :
           		<Button bsStyle="danger" onClick={this.hadleStoreCredit}>Withdrawal</Button>
        	}
            <Button bsStyle="primary" onClick={this.ClosePopup}>Close</Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

StoreCreditPreview.propTypes = {
  storeCredit: PropTypes.func.isRequired,
  storePreview: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  userList: state.subAdminReducer.userList,
  error: state.subAdminReducer.error,
  alertType: state.alertsReducer.alertType,
  storePrev: state.subAdminReducer.storeCredit,
  store: state.subAdminReducer.store,
  message: state.alertsReducer.message
});

export default connect(mapStateToProps, {
  storeCredit,
  renderAlert,
  clearAlert,
  storePreview
})(StoreCreditPreview);



// WEBPACK FOOTER //
// ./src/app/views/admin/user/StoreCreditPreview.js